import RequestService from './Utils/RequestService';
import storageAvailable from './Utils/StorageAvailable';

let accessToken = '_accessToken';
let refreshToken = '_refreshToken';

export default class Client {
    constructor(apiId, apiKey) {
        var storage;

        this._accessToken = undefined;
        this._refreshToken = undefined;
        if (storageAvailable('localStorage')) {
            storage = window.localStorage;

            if (storage.getItem(accessToken)) {
                this._accessToken = storage.getItem(accessToken);
                this._refreshToken = storage.getItem(refreshToken);
            }
        }

        this._apiKey = apiKey;
        this._apiId = apiId;
        this._requestService = new RequestService(apiId, apiKey);
    }

    login(loginRequest) {
        if (loginRequest.test === true) {
            return new Promise((resolve, reject) => {
                this.fakeApiData(loginRequest)
                    .then((result) => {
                        this._accessToken = result;
                        resolve('Ok');
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }

        loginRequest.apiId = this._apiId;
        loginRequest.apiKey = this._apiKey;

        return new Promise((resolve, reject) => {
            this._requestService.apiCall(loginRequest)
                .then((result) => {
                    this._accessToken = result;
                    resolve('Ok');
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    renewAccessToken() {
        var body = 'client_id=' + this._apiId +
            '&client_secret=' + this._apiKey +
            '&grant_type=refresh_token&refresh_token=' + this._refreshToken;

        if (this._refreshToken !== undefined) {
            this._requestService.post('/connect/token', body, 'application/x-www-form-urlencoded')
                .then(function (body) {
                    console.log(body);
                    this._accessToken = body.access_token;
                    this._refreshToken = body.refresh_token;
                    this._requestService.accessToken = body.access_token;
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    checkErrorIsUnauthorized(error) {
        if (error) {
            return false;
        }
        return false;
    }

    call(request) {
        // if (this._accessToken === undefined && !request.anonymous) {
        //     return new Promise((resolve, reject) => {
        //         reject('You are not logged in. Please use Client.login(username, password)');
        //     });
        // }

        if (request.test === true) {
            return this.fakeApiData(request);
        }

        return new Promise((resolve, reject) => {
            this._requestService.apiCall(request)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    if (!request. anonymous &&
                    this.checkErrorIsUnauthorized(error) &&
                    this._refreshToken !== undefined) {
                        this.renewAccessToken();
                        this._requestService.apiCall(request)
                            .then((result) => resolve(result))
                            .catch((error) => this.handleApiError(reject, error));
                    } else {
                        this.handleApiError(reject, error);
                    }
                });
        });
    }

    fakeApiData(request) {
        return new Promise((resolve, reject) => {
            if (request.success === true) {
                resolve(request.data);
            } else {
                reject(request.error);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/Client.js